module.exports = "<p>image-gallery works!</p>\n"